export const root = "r1ruvzay";
export const ctaBlock = "c59plgl";
export const ctaButtons = "c1uyx83k";
export const ctaButton = "c1m8o2he";
export const container = "c1irm15a";
export const memberInfo = "m1fnk0pc";
export const memberName = "m1i7ss6f";
export const logo = "l1blgy7i";
export const logoMember = "lovszyp";
export const v1Logo = "viwx0pr";
export const videoContainer = "v6vcm6z";
export const video = "v1uc1b87";
export const profileLink = "pwh7lim";
export const sponsoredText = "sdqnys5";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");